import React, { useState } from "react";
import { Box, Divider, Typography } from "@mui/material";

import MenuLateral from "./menuLateral";
import UsuariosView from "./usuariosView";
import PerfilesView from "./perfilesView";
import PermisosView from "./permisosView";

export default function AdminUserComponent() {
    const [vista, setVista] = useState<
        "usuarios" | "perfiles" | "permisos"
    >("usuarios");

    const renderVista = () => {
        switch (vista) {
            case "usuarios":
                return <UsuariosView />;

            case "perfiles":
                return <PerfilesView />;

            case "permisos":
                return <PermisosView />;

            default:
                return <UsuariosView />;
        }
    };

    const getTitulo = () => {
        switch (vista) {
            case "usuarios":
                return "Administración de Usuarios";

            case "perfiles":
                return "Administración de Perfiles";

            case "permisos":
                return "Administración de Permisos";

            default:
                return "";
        }
    };

    return (
        <Box
            display="flex"
            sx={{
                width: "100%",
                height: "calc(100vh - 70px)",
            }}
        >
            <MenuLateral
                vista={vista}
                setVista={setVista}
            />

            <Box
                sx={{
                    flex: 1,
                    p: 4,
                    bgcolor: "#fff",
                    overflow: "auto",
                }}
            >
                {/* Título */}
                <Typography
                    variant="h4"
                    fontWeight="bold"
                    mb={2}
                >
                    {getTitulo()}
                </Typography>

                <Divider sx={{ mb: 4 }} />

                {/* Contenido */}
                {renderVista()}
            </Box>
        </Box>
    );
}